// 奖励发放用户类型
export let auditTypes = [
  {
    label: '新用户',
    value: 'NEW'
  },
  {
    label: '老用户',
    value: 'OLD'
  }
]
// audit类型枚举
export let auditStatus = [
  {
    label: '待客服审核',
    value: 'WAITING_FOR_APPROVAL'
  },
  {
    label: '待财务审核',
    value: 'SALES_COMPLETED'
  },
  {
    label: '已完成',
    value: 'COMPLETED'
  },
  {
    label: '客服已驳回',
    value: 'SALES_REJECTED'
  },
  {
    label: '财务已驳回',
    value: 'REJECTED'
  },
  {
    label: '已退款',
    value: 'REFUND'
  }
]
// 手动发放奖励枚举
export let manualAuditStatus = [
  {
    label: '待初审',
    value: 'WAITING_FOR_APPROVAL'
  },
  {
    label: '待财务审核',
    value: 'SALES_COMPLETED'
  },
  {
    label: '已完成',
    value: 'COMPLETED'
  },
  {
    label: '客服已驳回',
    value: 'SALES_REJECTED'
  },
  {
    label: '财务已驳回',
    value: 'REJECTED'
  },
  {
    label: '已退款',
    value: 'REFUND'
  }
]
// 手动发放积分枚举
export let integralAuditStatus = [
  {
    label: '待审核',
    value: 'WAITING_FOR_APPROVAL'
  },
  {
    label: '已完成',
    value: 'COMPLETED'
  },
  {
    label: '已驳回',
    value: 'REJECTED'
  }
]
export let businessTypes = [
  {
    label: '脐荐康奖励',
    value: 'CUSTOMER_BRING_NEW_QJK'
  },
  {
    label: '母亲节活动奖励',
    value: 'CUSTOMER_BRING_NEW_MOTHERS_DAY'
  },
  {
    label: '老带新奖励',
    value: 'CUSTOMER_BRING_NEW'
  }
]
export let rewardTypes = [
  {
    label: '现金奖励',
    value: 'MONEY'
  },
  {
    label: '优惠券奖励',
    value: 'DISCOUNT_COUPON'
  }
]
// 提现状态
export let withdrawStatus = [
  {
    label: '处理中',
    value: 'PROCESSING'
  },
  {
    label: '待审核',
    value: 'WAITING_FOR_APPROVAL'
  },
  {
    label: '已完成',
    value: 'COMPLETED'
  },
  {
    label: '已驳回',
    value: 'REJECT'
  },
  {
    label: '已失败',
    value: 'FAILED'
  },
  {
    label: '已取消',
    value: 'CANCELLED'
  }
]
// 闪贷状态
export let flashBorrowStatus = [
  {
    label: '待申请',
    value: 'WAITING_FOR_APPLY'
  },
  {
    label: '待审核',
    value: 'WAITING_FOR_AUDIT'
  },
  {
    label: '待支付',
    value: 'WAITING_FOR_COMPLETE'
  },
  {
    label: '已完成',
    value: 'FLASH_COMPLETE'
  }
]
// 奖励汇总类型
export let allAuditTypes = [
  {
    label: '手动发放奖励',
    value: 'MANUAL_REWARD'
  },
  {
    label: '牙源成单奖励',
    value: 'TOOTH_ACHIEVEMENT_REWARD'
  },
  {
    label: '业务员奖励',
    value: 'SALES_REWARD'
  },
  {
    label: '邀请人奖励',
    value: 'INVITER_REWARD'
  },
  {
    label: '通用促销奖励',
    value: 'GENERIC_CASH_BACK'
  },
  {
    label: 'CPS绑定奖励',
    value: 'CPS_BIND'
  },
  {
    label: '老带新奖励',
    value: 'CUSTOMER_BRING_NEW'
  },
  {
    label: '母亲节活动奖励',
    value: 'CUSTOMER_BRING_NEW_MOTHERS_DAY'
  },
  {
    label: '脐荐康奖励',
    value: 'CUSTOMER_BRING_NEW_QJK'
  },
  {
    label: '医生邀请人奖励',
    value: 'DOCTOR_INVITER_REWARD'
  }
]
// 展示的奖励状态
export let showRewardStatus = [
  {
    label: '待客服审核',
    value: 'WAITING_FOR_APPROVAL'
  },
  {
    label: '待财务审核',
    value: 'SALES_COMPLETED'
  },
  {
    label: '客服已驳回',
    value: 'SALES_REJECTED'
  },
  {
    label: '财务已驳回',
    value: 'REJECTED'
  },
  {
    label: '已审核',
    value: 'COMPLETED'
  }
]
// 入库状态
export let rewardedStatus = [
  {
    label: '已入库',
    value: 'RECORDED'
  },
  {
    label: '未入库',
    value: 'UNRECORDED'
  },
  {
    label: '入库后退款',
    value: 'REFUND_AFTER_RECORDED'
  }
]
// 扫码缴费支付方式枚举
export let payOptions = [
  {
    label: '未指定任何渠道',
    value: 'none'
  },
  {
    label: '模拟支付',
    value: 'mock'
  },
  {
    label: '虚拟币支付',
    value: 'wallet'
  },
  {
    label: '账户余额支付',
    value: 'mymoney'
  },
  {
    label: '支付宝App支付',
    value: 'alipay'
  },
  {
    label: '支付宝手机网站支付',
    value: 'alipay_wap'
  },
  {
    label: '支付宝当面付',
    value: 'alipay_qr'
  },
  {
    label: '支付宝扫码支付(招行聚合支付)',
    value: 'alipay_qr_cmb'
  },
  {
    label: '支付宝条码支付',
    value: 'alipay_scan'
  },
  {
    label: '支付宝电脑网站支付',
    value: 'alipay_pc_direct'
  },
  {
    label: '微信App支付',
    value: 'wx'
  },
  {
    label: '微信公众号支付',
    value: 'wx_pub'
  },
  {
    label: '微信公众号支付(招行聚合支付)',
    value: 'wx_pub_cmb'
  },
  {
    label: '微信 H5 支付',
    value: 'wx_wap'
  },
  {
    label: '微信小程序支付',
    value: 'wx_lite'
  },
  {
    label: '微信公众号扫码支付',
    value: 'wx_pub_qr'
  },
  {
    label: '微信公众号刷卡支付',
    value: 'wx_pub_scan'
  },
  {
    label: '微信Native支付',
    value: 'wx_native'
  },
  {
    label: '微信Native支付(招行聚合支付)',
    value: 'wx_native_cmb'
  },
  {
    label: '支付宝手机网站支付(招行聚合支付)',
    value: 'alipay_wap_cmb'
  }
]
// 扫码缴费支付状态
export let payStaus = [
  {
    label: '待支付',
    value: 'WaitingForPayment'
  },
  {
    label: '已发起支付',
    value: 'StartedPayment'
  },
  {
    label: '支付成功',
    value: 'Completed'
  },
  {
    label: '支付失败',
    value: 'Failed'
  },
  {
    label: '用户已取消',
    value: 'UserCancelled'
  },
  {
    label: '系统已取消',
    value: 'SystemCancelled'
  }
]
